<app-pane title="Element Info" (visibleChange)="visibleChanged(container.visible)">
  <table *ngIf="anythingHit">
    <tr>
      <td>Step</td>
      <td>{{step}}</td>
    </tr>
    <tr>
      <td>Part</td>
      <td>{{hitItem.objectName}} (ID: {{hitItem.objectId}}, Index: {{hitItem.objectIndex}})</td>
      <td rowSpan="4"><img [class]="hitItem.elementType" /></td>
    </tr>
    <tr>
      <td>Element type</td>
      <td>{{hitItem.elementType}}</td>
    </tr>
    <tr>
      <td>Element</td>
      <td>ID: {{hitItem.elementId}}, Index: {{hitItem.elementIndex}}</td>
    </tr>
    <tr>
      <td>Closest node</td>
      <td>ID: {{hitItem.nodeId}}, Index: {{hitItem.nodeIndex}}</td>
    </tr>
    <tr>
      <td>Hit coordinate</td>
      <td>{{coordinate}}</td>
    </tr>
    <tr *ngIf="hasElementResult">
      <td>Element result</td>
      <td>{{elementResult}}</td>
    </tr>
    <tr *ngIf="hasNodeResult">
      <td>Node result</td>
      <td>{{nodeResult}}</td>
    </tr>
  </table>
</app-pane>
